import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";

const BasicInfoTab = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="name">
            Exam Name <span className="text-red-500">*</span>
          </Label>
          <Input
            id="name"
            value={formData.name}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
            placeholder="Enter exam name"
            required
          />
        </div>
        <div>
          <Label htmlFor="totalTime">Duration (minutes)</Label>
          <Input
            id="totalTime"
            type="number"
            value={formData.totalTime}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                totalTime: parseInt(e.target.value),
              }))
            }
            min="1"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              description: e.target.value,
            }))
          }
          placeholder="Enter exam description"
        />
      </div>

      <div>
        <Label htmlFor="instructions">Instructions</Label>
        <Textarea
          id="instructions"
          value={formData.instructions}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              instructions: e.target.value,
            }))
          }
          placeholder="Enter exam instructions for candidates"
        />
      </div>

      <div className="flex items-center space-x-2">
        <Switch
          id="isTemplate"
          checked={formData.isTemplate}
          onCheckedChange={(checked) =>
            setFormData((prev) => ({
              ...prev,
              isTemplate: checked,
            }))
          }
        />
        <Label htmlFor="isTemplate">Save as Template</Label>
      </div>
    </div>
  );
};

export default BasicInfoTab;
